import { type Plan, type CardBrand, type Transaction } from "../models/payment"

export const getCardBrandDisplayName = (brand: CardBrand | null): string | null => {
	switch (brand) {
		case "visa":
			return "Visa"
		case "mastercard":
			return "MasterCard"
		case "amex":
			return "American Express"
		case "discover":
			return "Discover Card"
		case "diners":
			return "Diners Club"
		case "unionpay":
			return "Union Pay"
		case "jcb":
			return "JCB Card"
		default:
			return "Unknown card"
	}
}

export function toPaymentStatusString(status: Transaction["status"]): string {
	switch (status) {
		case "success":
			return "Succeeded"
		case "pending":
			return "Pending"
		case "failed":
			return "Failed"
	}
}

export function toPaymentGatewayString(gateway: "stripe" | "paypal"): string {
	switch (gateway) {
		case "stripe":
			return "Stripe"
		case "paypal":
			return "PayPal"
	}
}

export function getPlansAnnualDiscount(plans: Plan[]): number {
	return Math.max(
		...plans.flatMap(x =>
			x.prices !== null
				? 1 -
					(x.prices.platform?.year.amount ?? x.prices.current.year.amount) /
						((x.prices.platform?.month.amount ?? x.prices.current.month.amount) * 12)
				: 0,
		),
	)
}
